import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Panel } from 'components/layout'
import { Button } from 'components/misc'
import { StateSwitcher } from 'containers/misc'
import { PROGRESS_STATES } from 'constants/enums'
import { ACTIVITY_STATE_CATEGORIES } from '../../../../constants/enums'

export default class ActivityState extends Component {
  static propTypes = {
    activityId: PropTypes.number.isRequired,
    activityState: PropTypes.object.isRequired,
    changeActivityState: PropTypes.func.isRequired,
    componentApproval: PropTypes.object,
    hasOneActivity: PropTypes.bool,
    componentSignoff: PropTypes.object,
    onRestoreActivity: PropTypes.func,
    validationData: PropTypes.object
  }
  static defaultProps = {
    activityState: {}
  }

  render() {
    const {
      activityState,
      changeActivityState,
      activityId,
      componentSignoff,
      componentApproval,
      hasOneActivity,
      onRestoreActivity,
      validationData
    } = this.props

    const forbiddenActivityStates = [
      PROGRESS_STATES.activitySetup.id,
      PROGRESS_STATES.activityCeremony.id,
      PROGRESS_STATES.activityComplete.id,
      PROGRESS_STATES.activityInactive.id
    ]

    const states = {
      [PROGRESS_STATES.activitySetup.id]: {
        id: PROGRESS_STATES.activitySetup.id,
        label: 'Setup',
        intlKey: 'states.setup',
        content: null,
        disabledStates: [
          PROGRESS_STATES.activityApproval.id,
          PROGRESS_STATES.activityAssessment.id,
          PROGRESS_STATES.activityOfficeSignoff.id,
          PROGRESS_STATES.activityInProgress.id,
          PROGRESS_STATES.activityLeaderSignoff.id,
          hasOneActivity && PROGRESS_STATES.activityDeleted.id,
          ...forbiddenActivityStates
        ]
      },
      [PROGRESS_STATES.activityApproval.id]: {
        id: PROGRESS_STATES.activityApproval.id,
        label: 'Approval',
        intlKey: 'states.approval',
        content: componentApproval,
        disabledStates: [
          PROGRESS_STATES.activityInProgress.id,
          PROGRESS_STATES.activityAssessment.id,
          PROGRESS_STATES.activityLeaderSignoff.id,
          PROGRESS_STATES.activityOfficeSignoff.id,
          PROGRESS_STATES.activityDeleted.id,
          ...forbiddenActivityStates
        ]
      },
      [PROGRESS_STATES.activityInProgress.id]: {
        id: PROGRESS_STATES.activityInProgress.id,
        label: 'In progress',
        intlKey: 'states.in_progress',
        content: null,
        disabledStates: [
          PROGRESS_STATES.activityLeaderSignoff.id,
          PROGRESS_STATES.activityOfficeSignoff.id,
          hasOneActivity && PROGRESS_STATES.activityDeleted.id,
          ...forbiddenActivityStates
        ]
      },
      [PROGRESS_STATES.activityAssessment.id]: {
        id: PROGRESS_STATES.activityAssessment.id,
        label: 'Assessor approval',
        intlKey: 'states.assessor_approval',
        content: null,
        disabledStates: [
          PROGRESS_STATES.activityApproval.id,
          PROGRESS_STATES.activityOfficeSignoff.id,
          ...forbiddenActivityStates
        ]
      },
      [PROGRESS_STATES.activityLeaderSignoff.id]: {
        id: PROGRESS_STATES.activityLeaderSignoff.id,
        label: 'Awaiting Sign-off',
        intlKey: 'states.awaiting_sign_off',
        content: componentSignoff,
        disabledStates: [
          PROGRESS_STATES.activityApproval.id,
          PROGRESS_STATES.activityAssessment.id,
          PROGRESS_STATES.activityOfficeSignoff.id,
          PROGRESS_STATES.activityInProgress.id,
          ...forbiddenActivityStates
        ]
      },
      [PROGRESS_STATES.activityOfficeSignoff.id]: {
        id: PROGRESS_STATES.activityOfficeSignoff.id,
        label: 'Awaiting Office Sign-off',
        intlKey: 'states.awaiting_office_sign_off',
        content: null,
        disabledStates: [
          PROGRESS_STATES.activityApproval.id,
          PROGRESS_STATES.activityInProgress.id,
          PROGRESS_STATES.activityAssessment.id,
          ...forbiddenActivityStates
        ]
      },
      [PROGRESS_STATES.activityComplete.id]: {
        id: PROGRESS_STATES.activityComplete.id,
        label: 'Completed',
        intlKey: 'states.completed',
        content: null,
        disabledStates: ['DISABLED']
      },
      [PROGRESS_STATES.activityCeremony.id]: {
        id: PROGRESS_STATES.activityCeremony.id,
        label: 'Ceremony & Certificate',
        intlKey: 'states.ceremony_certificate',
        content: null,
        disabledStates: ['DISABLED'],
        isLast: true
      },

      [PROGRESS_STATES.activityInactive.id]: {
        id: PROGRESS_STATES.activityInactive.id,
        label: 'Inactive',
        intlKey: 'states.inactive',
        content: null,
        disabledStates: ['DISABLED'],
        hasSeparator: true
      }
    }

    // has multiple
    if (!hasOneActivity) {
      states[PROGRESS_STATES.activityDeleted.id] = {
        id: PROGRESS_STATES.activityDeleted.id,
        label: 'Deleted',
        intlKey: 'states.deleted',
        content: null,
        disabledStates: ['DISABLED']
      }
    }

    return (
      <div>
        <StateSwitcher
          id={activityId}
          state={activityState}
          states={states}
          changeState={changeActivityState}
          validationData={validationData}
          stateType={ACTIVITY_STATE_CATEGORIES.activity.id}
        />
        {activityState.value === PROGRESS_STATES.activityDeleted.id && (
          <Panel>
            <FormattedMessage
              tagName="p"
              id="label.activity_deleted_note"
              defaultMessage="This activity is deleted. You can restore it by clicking the button below."
            />
            <Button
              onClick={onRestoreActivity}
              small
              type="button"
              intlKey="button.restore_activity"
            >
              Restore Activity
            </Button>
          </Panel>
        )}
      </div>
    )
  }
}
